<template>
  <AlertDialogRoot>
    <AlertDialogTrigger
      class="inline-flex h-[35px] items-center justify-center rounded-sm px-[15px] leading-none outline-none transition-all text-muted-foreground hover:text-foreground"
    >
      <X v-if="showIcon" :size="16" class="mr-2" />
      <slot name="icon">Cancel</slot>
    </AlertDialogTrigger>
    <AlertDialogPortal>
      <AlertDialogOverlay
        class="bg-opacity-50 [backdrop-filter:blur(1.4px)] data-[state=open]:animate-overlayShow fixed inset-0 z-[999]"
      />
      <AlertDialogContent
        class="z-[1000] text-[15px] data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] p-[25px] pb-4 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none rounded-lg"
        :class="{
          '!bg-background-light': mode === 'light',
          '!bg-sidebar-accent': mode === 'dark',
        }"
      >
        <AlertDialogTitle class="text-mauve12 m-0 text-[17px] font-semibold pb-3">
          Your changes won't be saved
        </AlertDialogTitle>
        <AlertDialogDescription class="text-muted-foreground mt-4 mb-5 text-[15px] leading-normal pb-5">
          We won't be able to save your data if you move away from this page.
        </AlertDialogDescription>
        <div class="flex justify-end gap-[15px] pt-3">
          <AlertDialogCancel
            class="border-2 border-gray-100 py-5 text-mauve11 bg-mauve4 hover:bg-mauve5 focus:shadow-none inline-flex h-[35px] items-center justify-center rounded-[4px] px-[15px] font-medium leading-none outline-none focus:outline-none"
          >
            Go Back
          </AlertDialogCancel>
          <AlertDialogAction
            class="text-white !bg-red-600 py-5 mt-0.5 hover:!bg-red-700 focus:shadow-red7 inline-flex h-[35px] items-center justify-center rounded-[4px] px-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]"
            @click="triggerDialogShouldClose"
          >
            Discard
          </AlertDialogAction>
        </div>
      </AlertDialogContent>
    </AlertDialogPortal>
  </AlertDialogRoot>
</template>

<script setup lang="ts">
import { X } from 'lucide-vue-next'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogRoot,
  AlertDialogTitle,
  AlertDialogTrigger,
} from 'radix-vue'
import { useColorMode } from '@/composables/src/useColorMode'

// Reverted: Explicitly define props as empty if not already auto-inferred as such
defineProps<{ showIcon?: boolean }>()

const emit = defineEmits<{
  (e: 'dialogShouldClose'): void
}>()

const { mode } = useColorMode()

const triggerDialogShouldClose = () => {
  emit('dialogShouldClose')
}
</script>

<style scoped>
/* Add any additional styles here */
</style>
